import { clx } from '@medusajs/ui';
import * as Icons from '@medusajs/icons';
import { memo } from 'react';

type FabButtonProps = {
  iconName: keyof typeof Icons;
  className?: string;
  'data-testid'?: string;
  onClick?: () => void;
};

/**
 * Floating Action Button with icon from @medusajs/icons
 */
const FabButton = memo(({ iconName, className, 'data-testid': testId, onClick }: FabButtonProps) => {
  const IconComponent = Icons[iconName] as React.ComponentType;

  if (!IconComponent) {
    return null;
  }

  return (
    <button
      className={clx(
        'rounded-full p-4 transition-colors bg-white-30 text-black-50 hover:text-primary-20 active:bg-primary-10_op10',
        className
      )}
      onClick={onClick}
      data-testid={testId}
    >
      <IconComponent />
    </button>
  );
});

FabButton.displayName = 'FabButton';

export default FabButton;
